var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEnvironmentIconFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000163078 2.33301V0.999674H1.99984C4.57717 0.999674 6.6665 3.08901 6.6665 5.66634V7.66634H9.99984V12.333C9.99984 13.0697 9.40317 13.6663 8.6665 13.6663H3.33317C2.5965 13.6663 1.99984 13.0697 1.99984 12.333V7.66634H5.33317V6.99967H4.6665C2.08917 6.99967 -0.000163078 4.91034 -0.000163078 2.33301ZM6.2505 2.44567C7.1565 1.16701 8.64717 0.333008 10.3332 0.333008H12.6665V1.33301C12.6665 4.09434 10.4278 6.33301 7.6665 6.33301H7.33317V5.66634C7.33317 4.45634 6.9305 3.33967 6.2505 2.44567ZM3.33317 8.99963H8.6665V9.6663H3.33317V8.99963ZM8.6665 10.9996H3.33317V12.333H8.6665V10.9996ZM3.6215 4.00275C3.62163 4.00285 3.62376 4.00257 3.62748 4.00157C3.62322 4.00214 3.62137 4.00264 3.6215 4.00275ZM3.66683 3.33293C4.2209 3.33293 4.66749 3.71078 4.97307 4.07807C5.28919 4.45801 5.52211 4.90694 5.64299 5.20913L6.02182 6.15621L5.15683 5.61559C4.70813 5.33515 4.07472 4.90806 3.65004 4.54447C3.54301 4.45283 3.44421 4.36099 3.36314 4.27304C3.28672 4.19013 3.20652 4.09008 3.1593 3.98201C3.11361 3.87745 3.05922 3.65554 3.23741 3.47858C3.37087 3.34602 3.55685 3.33293 3.66683 3.33293Z",
    fill: "#6C7E8E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnvironmentIconFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EnvironmentIconFilled.34eac95f.svg";
export { ForwardRef as ReactComponent };